import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import { useAppDispatch } from "../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import MobileHeader from "../../../layout/OwnerLayout/Header";
import DoneBolsCard from "./DoneBolsCard";
import CustomDatePicker from "../../../components/DatePicker";
import { useFormik } from "formik";

import CustomSelectOption from "../../../components/CustomSelectOption";
import { Day } from "react-modern-calendar-datepicker";
import { toGregorian } from "jalaali-js";
import { useInView } from "react-intersection-observer";
import EmptyListBox from "../../../components/EmptyListBox";
import LoadingBox from "../../../components/LoadingBox";
import { IBolItem } from "../../../../types/bolsHistories";

export default function BolsHistories() {
  const dispatch = useAppDispatch();

  const [bolsList, setBolsList] = useState<IBolItem[]>([]);

  const [filterDate, setFilterDate] = useState<Day | null>();

  const [pageCounts, setPageCounts] = useState(0);

  const [pageN, setPageN] = useState(1);

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const formik = useFormik({
    initialValues: {
      pageNr: 1,
      shipStatus: 0,
      payStatus: 0,
    },
    onSubmit: (values) => {
      const newValues = {
        ...values,
        shipStatus: values.shipStatus || null,
        payStatus: values.payStatus || null,
      };

      getBolsGistories(newValues);
    },
  });

  const { trigger: getBolsGistories, isMutating: isgetBolsGistoriesMutting } =
    useSWRMutation(
      [`/Nobat/OwnerBolList`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          setBolsList(data.data);
          setPageCounts(data.count);
        },
      }
    );

  const {
    trigger: getBolsGistoriesNextPage,
    isMutating: isgetBolsGistoriesMuttingNextPage,
  } = useSWRMutation(
    [`/Nobat/OwnerBolList`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setBolsList([...bolsList, ...data.data]);
      },
    }
  );

  useEffect(() => {
    getBolsGistories({
      pageNr: 1,
    });
    //     {
    //   getActiveNobat: false,
    //   nobatStatus: 0,
    //   pageNr: 1,
    // }
  }, []);

  const handleChangeSelectOption = (value: any, type: string) => {
    console.log(type, value);

    setPageN(1);

    setBolsList([]);

    switch (type) {
      case "shipStatus":
        formik.setFieldValue("shipStatus", Number(value) || null);
        formik.handleSubmit();
        break;

      case "payStatus":
        formik.setFieldValue("payStatus", Number(value) || null);
        formik.handleSubmit();
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (inView && pageCounts > bolsList.length) {
      setPageN((prev) => prev + 1);
    }
  }, [inView]);

  useEffect(() => {
    getBolsGistoriesNextPage({
      pageNr: pageN,
      shipStatus: formik.values.shipStatus || null,
    });
  }, [pageN]);

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            سوابق بارنامه
          </Typography>
        }
      />
      <Grid
        container
        spacing={1}
        sx={{
          width: "100%",
          paddingX: "8px",
        }}
      >
        <Grid item xs={4}>
          <CustomSelectOption
            type="shipStatus"
            setValue={handleChangeSelectOption}
            value={formik.values.shipStatus?.toString() || "0"}
            // error={companyActivity.error}
            // errorMessage={companyActivity.errorMessage}
            options={[
              {
                value: 0,
                label: "رسید کالا",
                disabled: true,
              },
              {
                value: 2,
                label: "رسید نشده",
              },
              {
                value: 5,
                label: "رسید شده",
              },
              {
                value: 0,
                label: "همه موارد",
              },
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <CustomSelectOption
            type="payStatus"
            setValue={handleChangeSelectOption}
            value={formik.values.payStatus?.toString() || "0"}
            // error={companyActivity.error}
            // errorMessage={companyActivity.errorMessage}
            options={[
              {
                value: 0,
                label: "پرداخت کرایه",
                disabled: true,
              },
              {
                value: 1,
                label: "پرداخت شده",
              },
              {
                value: 2,
                label: "پرداخت نشده",
              },
              {
                value: 0,
                label: "همه موارد",
              },
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <CustomDatePicker
            value={filterDate || null}
            handleResetDate={() => {
              formik.setFieldValue("bolDate", null);
              setFilterDate(null);

              formik.handleSubmit();
            }}
            // error={
            //   loadingDateFotmik.touched.loadingDate &&
            //   Boolean(loadingDateFotmik.errors.loadingDate)
            // }
            // errorMessage={
            //   loadingDateFotmik.touched.loadingDate &&
            //   loadingDateFotmik.errors.loadingDate
            // }
            onChange={(value) => {
              setPageN(1);
              setBolsList([]);
              if (value) {
                const { gd, gm, gy } = toGregorian(
                  value?.year,
                  value?.month,
                  value?.day
                );
                formik.setFieldValue(
                  "bolDate",
                  new Date(gy, gm - 1, gd + 1).toISOString()
                );
                setFilterDate(value);
              }
              formik.handleSubmit();
            }}
            label={"تاریخ بارنامه"}
          />
        </Grid>
      </Grid>

      {isgetBolsGistoriesMutting ? (
        <LoadingBox />
      ) : !bolsList.length ? (
        <EmptyListBox description="بارنامه‌ای وجود ندارد!" />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingX: "8px",
            gap: "8px",
          }}
        >
          {bolsList.map((item, index) => (
            <>
              <DoneBolsCard
                ref={index + 1 === pageN * 10 ? ref : null}
                key={item.id}
                {...item}
              />
              {isgetBolsGistoriesMuttingNextPage &&
                index === bolsList.length - 1 && <LoadingBox />}
            </>
          ))}
        </Box>
      )}
    </>
  );
}
